import { BiBorderRadius } from "react-icons/bi";
import { LuSearch, LuChevronDown } from "@/Components/Icons/Icons";
export default {
  row1: [
    {
      column: "column1",
      columnWidth: "60%",
      rows: {
        row1: [
          {
            name: "manufacturerName",
            label: "Name",
            component: "text-field",
            icon: LuSearch,
            iconColor: "gray-400",
            type: "autocomplete",
            endpoint: "getCustomers",
            autofillTargets: {
              manufacturerAddressId: "address",
            },
            endPointWithId : "getCustomersAddress"
          },
        ],
        row2: [
          {
            name: "manufacturerCode",
            label: "Code",
            component: "text-field",

          },
          {
            name: "code",
            component: "text-field",
            // disabled: true,
          },
        ],
        row3: [
          {
            name: "manufacturerAddressId",
            label: "Address",
            component: "dropdown",
            endIconName: LuChevronDown,
            iconColor: "gray-400",
            type: "autocomplete",
            autofillTargets: {
              manufacturerAddress: "addressLine",
              manufacturerState: "state",
              manufacturerCountry: "country",
              manufacturerPostalCode:"pincode"
            },
          },
        ],
        row4: [
          {
            name: "manufacturerAddress",
            component: "textarea",
            width : "100%",
            sx: {
              height: "70px",
            },
            // disabled: true,
          },
        ],
        row5: [
          {
            name: "manufacturerCountry",
            label: "Country",
            component: "text-field",
            icon: LuSearch,
            iconColor: "gray-400",
            type: "autocomplete",
            endpoint: "getCountry"
            // disabled: true,
          },
        ],
        row6: [
          {
            name: "manufacturerState",
            label: "State/Province",
            component: "text-field",
            // disabled: true,
          },
        ],
        row7: [
          {
            name: "manufacturerPostalCode",
            label: "Postal Code",
            component: "text-field",
            // disabled: true,
          },
        ],
      },
    },
    {
      column: "column2",
      columnWidth: "60%",
      rows: {
        row1: [
          {
            name: "manufacturerBrand",
            label: "Brand",
            component: "text-field",
            // disabled: true,

          },
        ],
        row2: [
          {
            name: "manufacturerModel",
            label: "Model",
            component: "text-field",
            // disabled: true,
          },
        ],
        row3: [
          {
            name: "manufacturerEndUse",
            label: "End Use",
            component: "text-field",
            icon: LuSearch,
            iconColor: "gray-400",
            type: "autocomplete",
            endpoint: "getEndUseCode"
            // disabled: true,
          },
        ],
        row4: [
          {
            name: "manufacturerCountryOfOrigin",
            label: "Country Origin",
            component: "text-field",
            icon: LuSearch,
            iconColor: "gray-400",
            type: "autocomplete",
            endpoint: "getCountry"
            // disabled: true,
          },
        ],
        row5: [
          {
            name: "manufacturerSourceOfCountry",
            label: "Source Country",
            component: "text-field",
            icon: LuSearch,
            iconColor: "gray-400",
            type: "autocomplete",
            endpoint: "getCountry"
            //disabled: true,
          },
        ],
        row6: [
          {
            name: "manufacturerTransitCountry",
            label: "Transit Country",
            component: "text-field",
            icon: LuSearch,
            iconColor: "gray-400",
            type: "autocomplete",
            endpoint: "getCountry"
            // disabled: true,
          },
        ],
      },
    },
  ]
};
